import React from "react";
import { validateProperty } from "../../common/validate";

import { Input, CardElementInput } from "../../common/Input";
import {
  CardNumberElement,
  CardExpiryElement,
  CardCvcElement
} from "react-stripe-elements";

const PaymentDetails = ({ data, setData, errors, setErrors, submitOnce }) => {
  const handleChange = ({ currentTarget: input }) => {
    if (submitOnce) {
      const newErrors = { ...errors };
      const errorMessage = validateProperty(input, "payment_details");
      if (errorMessage) newErrors[input.name] = errorMessage;
      else delete newErrors[input.name];
      setErrors(newErrors);
    }

    setData({
      ...data,
      [input.name]: input.value
    });
  };

  const handleCardElementChange = (element, name) => {
    const newErrors = { ...errors };

    if (submitOnce) {
      if (element.empty) newErrors[name] = "You can't leave this field empty";
      else delete newErrors[name];
    }

    if (element.error) {
      newErrors[name] = element.error.message;
    }

    setErrors(newErrors);

    setData({
      ...data,
      [name]: !element.empty
    });
  };

  return (
    <>
      <div className="row mb-3">
        <h2>Payment Details</h2>
      </div>
      <div className="row mb-md mb-md-mobile-off">
        <div className="col-12 col-md-6">
          <Input
            label="NAME ON CARD"
            name="card_name"
            data={data}
            errors={errors}
            type="text"
            onChange={handleChange}
          />
        </div>
        <div className="col-12 col-md-6">
          <CardElementInput
            label="CARD NUMBER"
            name="card_number"
            data={data}
            errors={errors}
            component={CardNumberElement}
            onChange={element =>
              handleCardElementChange(element, "card_number")
            }
          />
        </div>
      </div>
      <div className="row mb-lg">
        <div className="col-12 col-md-6">
          <div className="row">
            <div className="col-6">
              <CardElementInput
                label="EXPIRY"
                name="card_expiry"
                data={data}
                errors={errors}
                component={CardExpiryElement}
                onChange={element =>
                  handleCardElementChange(element, "card_expiry")
                }
                half={true}
              />
            </div>
            <div className="col-6">
              <CardElementInput
                label="CVC"
                name="card_cvc"
                data={data}
                errors={errors}
                component={CardCvcElement}
                onChange={element =>
                  handleCardElementChange(element, "card_cvc")
                }
                half={true}
              />
            </div>
          </div>
        </div>
        <div className="col-12 col-md-6">
          <Input
            label="EMAIL ADDRESS"
            name="email"
            data={data}
            errors={errors}
            type="text"
            onChange={handleChange}
          />
        </div>
      </div>
    </>
  );
};

export default PaymentDetails;
